// معرفی گروه کالا و خدمات
import React from 'react';
import { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import CrudView from './CrudView';
import { Field, TextInput } from './basicShared';

const COLS = [
  { key: 'code', label: 'کد گروه' }, { key: 'title', label: 'عنوان گروه' }, { key: 'amount', label: 'مبلغ', num: true },
];

function Fields({ f, set }) {
  return (
    <div style={ui.row}>
      <Field label="کد گروه کالا و خدمات" width="150px"><TextInput value={f.code} onChange={v => set('code', v)} ltr autoFocus /></Field>
      <Field label="عنوان"><TextInput value={f.title} onChange={v => set('title', v)} /></Field>
    </div>
  );
}

function Filters({ opts, setOpts, meta }) {
  const from = opts.from ?? meta.from_date ?? '';
  const to = opts.to ?? meta.to_date ?? '';
  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'flex-end' }}>
      <Field label="درخواستهای انجام شده: از" width="140px">
        <JalaliDatePicker value={from} onChange={v => setOpts(o => ({ ...o, from: v, to }))} />
      </Field>
      <Field label="تا" width="140px">
        <JalaliDatePicker value={to} onChange={v => setOpts(o => ({ ...o, to: v, from }))} />
      </Field>
    </div>
  );
}

export default function GoodsGroup({ user, onBack }) {
  return (
    <CrudView user={user} onBack={onBack} form="FRMGOODSGROUP" title="گروه کالا و خدمات" unit="گروه"
      path="/goods-groups" cols={COLS} empty={{ code: '', title: '' }} renderFields={Fields}
      listQuery={o => (o.from !== undefined || o.to !== undefined
        ? `&from=${encodeURIComponent(o.from || '')}&to=${encodeURIComponent(o.to || '')}` : '')}
      filters={Filters} changeBtn="BTNCHANGEID" />
  );
}
